import JwtService from '@/services/JwtService';
import AuthService from '@/infrastructure/auth/services/AuthService';
import UserService from '@/taskflex/users/services/UserService';

import {
    LOGIN,
    LOGIN_SUCCESS,
    LOGOUT,
    SET_USER,
    UNSET_USER,
} from './_types';

export default {
    login({ commit, dispatch }, credentials) {
        return new Promise((resolve, reject) => {
            commit(LOGIN);

            const options = {
                email: credentials.email,
                password: credentials.password,
            };

            AuthService.login(options, (loginResponse) => {
                const { data } = loginResponse;

                JwtService.saveToken(data.access_token);
                JwtService.setAuthHeader();

                const userId = JwtService.getUserId();

                dispatch('loadUser', userId)
                    .then((user) => {
                        commit(LOGIN_SUCCESS);

                        resolve(user);
                    })
                    .catch(dispatchResponse => reject(dispatchResponse));
            }, response => reject(response));
        });
    },

    reloadUser({ dispatch }) {
        return new Promise((resolve, reject) => {
            dispatch('loadUser', JwtService.getUserId())
                .then(() => {
                    resolve();
                })
                .catch(loadUserResponse => reject(loadUserResponse));
        });
    },

    loadUser({ commit }, userId) {
        return new Promise((resolve, reject) => {
            const options = { includes: ['account'] };

            UserService.find(userId, options, (response) => {
                const { data } = response;

                commit(SET_USER, data);

                resolve(data);
            }, (response) => {
                reject(response);
            });
        });
    },

    autoLogin({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken() == null) {
                reject();
                return;
            }

            JwtService.setAuthHeader();

            dispatch('refreshToken')
                .then((refreshTokenResponse) => {
                    const { data } = refreshTokenResponse;

                    const userId = JwtService.getUserId(data.access_token);

                    dispatch('loadUser', userId)
                        .then(() => {
                            commit(LOGIN_SUCCESS);

                            resolve();
                        })
                        .catch(loadUserResponse => reject(loadUserResponse));
                })
                .catch(response => reject(response));
        });
    },

    // eslint-disable-next-line no-unused-vars
    refreshToken({ commit }, options) {
        return new Promise((resolve, reject) => {
            AuthService.refresh(options, (response) => {
                const { data } = response;

                JwtService.saveToken(data.access_token);
                JwtService.setAuthHeader();

                resolve(response);
            }, (response) => {
                JwtService.clearToken();
                reject(response);
            });
        });
    },

    logout({ commit, dispatch }) {
        JwtService.clearToken();

        commit(UNSET_USER);
        commit(LOGOUT);
        dispatch('conversations/resetAll', null, { root: true });
    },
};



// WEBPACK FOOTER //
// ./src/infrastructure/auth/store/_actions.js